import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class HelperService {
    constructor() { }
    public validatePassword(value: string) {
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumeric = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value);
        return !(hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar);
    }

    public validateSlackUrl(value: string) {
        return /^https:\/\/hooks\.slack\.com\/.+$/.test(value);
    }
    // Teams Workflows (Power Automate) webhook URLs. Accepts the current powerplatform.com format and the older logic.azure.com format.
    public validateTeamsUrl(value: string) {
        const powerPlatform = /^https:\/\/[a-z0-9-]+(\.[a-z0-9-]+)*\.environment\.api\.powerplatform\.com(:443)?\/powerautomate\/automations\/direct\/([a-z0-9-]+\/)*workflows\/[a-f0-9-]+\/triggers\/manual\/paths\/invoke\?(.*&)?sig=[^&]+(&.*)?$/i;
        const logicApps = /^https:\/\/[a-z0-9-]+\.[a-z0-9-]+\.logic\.azure\.com(:443)?\/workflows\/[a-f0-9-]+\/triggers\/manual\/paths\/invoke\?(.*&)?sig=[^&]+(&.*)?$/i;
        return powerPlatform.test(value) || logicApps.test(value);
    }
    public validateZapierUrl(value: string) {
        return /^https:\/\/hooks\.zapier\.com\/.+$/.test(value);
    }
}
